import { FC, useCallback } from "react";
import { CircularProgress, IconButton } from "@mui/material";
import { Download } from "@mui/icons-material";
import { useSnackbar } from "notistack";
import { useIntl } from "react-intl";

import { useApiCall } from "@framework/react-hooks";

export interface IReportDownloadButtonProps {
  idReport: number;
}

export const ReportDownloadButton: FC<IReportDownloadButtonProps> = props => {
  const { idReport } = props;

  const { enqueueSnackbar } = useSnackbar();
  const { formatMessage } = useIntl();

  const { fn: download, isLoading: isReportDownloading } = useApiCall(
    (api, idReport: number) => {
      return api
        .fetchFile({
          url: `/report/${idReport}/pdf`,
          method: "GET",
        })
        .catch((error: any) => {
          console.error(error);
          enqueueSnackbar(formatMessage({ id: "pages.journals.reports.downloadError" }), { variant: "error" });
        });
    },
    { success: false, error: false },
  );

  const handleDownload = useCallback(async () => {
    await download(undefined, idReport);
  }, [idReport]);

  return (
    <IconButton onClick={() => void handleDownload()} sx={{ color: "inherit", justifyContent: "flex-end" }}>
      {isReportDownloading ? <CircularProgress size={20} /> : <Download />}
    </IconButton>
  );
};
